module.exports = __webpack_public_path__ + "img/cordoba.5d96fac1.png";